import { useEffect } from "react";
import { RouterProvider } from "react-router-dom";
import { AuthTrackingProvider } from "@core/features/tracking";
import useSyncFirebaseToken from "@core/services/api/useSyncFirebaseToken";
import { usePlatformStore } from "./store";
import { PlatformEventListeners } from "./PlatformEventListeners";
import { router } from "./router";
import { useSystemVariable } from "./hooks/useSystemVariable";
import type { MarketingSiteMode } from "@core/features/marketing";

export function PlatformApp() {
  const setTokenExpiredStatus = usePlatformStore((s) => s.setTokenExpired);
  const setMarketingSiteMode = usePlatformStore((s) => s.setMarketingSiteMode);

  useSyncFirebaseToken({ setTokenExpiredStatus });

  // Fetch marketing site mode on app init
  const { data: marketingSiteModeVar } = useSystemVariable(
    "marketing_site_mode"
  );

  // Update store when system variable is fetched
  useEffect(() => {
    if (marketingSiteModeVar?.value) {
      setMarketingSiteMode(marketingSiteModeVar.value as MarketingSiteMode);
    }
  }, [marketingSiteModeVar, setMarketingSiteMode]);

  const user = usePlatformStore((s) => s.user);
  const isTokenExpired = usePlatformStore((s) => s.isTokenExpired);

  return (
    <AuthTrackingProvider
      debug={{ enabled: false }}
      user={user || ({} as any)}
      organization={{} as any}
      isTokenExpired={isTokenExpired ?? false}
    >
      <PlatformEventListeners />
      <RouterProvider router={router} />
    </AuthTrackingProvider>
  );
}
